import Stack from '@mui/material/Stack'

import { P, Text } from '@mxenabled/mxui'
import { Icon } from '@mxenabled/mx-icons'

import { NetWorthCopy } from '../../../core'
import { formatCurrency } from '../../../core/utils/NumberFormatting'

interface NetworthDataProps {
  amount: number
  copy: NetWorthCopy
  trendValue: number
}

const NetworthData = ({ amount, copy, trendValue }: NetworthDataProps) => {
  const isTrendUp = trendValue > 0
  const trendDirectionIcon = isTrendUp ? 'trending_up' : 'trending_down'
  const trendIcon = trendValue === 0 ? 'trending_flat' : trendDirectionIcon

  return (
    <Stack sx={{ flexDirection: 'row', justifyContent: 'space-between' }}>
      <P variant="h1">{formatCurrency(amount, '0,0')}</P>
      {amount !== 0 && (
        <Stack sx={{ color: isTrendUp ? 'success.main' : 'text.secondary' }}>
          <Stack sx={{ flexDirection: 'row', gap: 8 }}>
            <Icon name={trendIcon} size={20} />
            <Text sx={{ fontWeight: 600, textAlign: 'right' }} variant="body1">
              {formatCurrency(trendValue, '0,0.00')}
            </Text>
          </Stack>
          <Text sx={{ display: 'block', textAlign: 'right' }} variant="caption">
            {copy.this_month}
          </Text>
        </Stack>
      )}
    </Stack>
  )
}

export default NetworthData
